var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "124px",
    viewBox: "0 0 119 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E2846713-DB64-4034-9F6E-4C9D5483592E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.8735,0 C110.7659,0 118,7.2111 118,16.0739 L118,16.0739 L118,106.9261 C118,115.7889 110.7659,123 101.8735,123 L101.8735,123 L52.7927,123 C45.0504,123 38.5701,117.5317 37.022,110.2682 C34.9234,110.8705 32.7041,110.7126 30.7008,109.7926 C12.0511,101.2315 0,82.4809 0,62.0214 C0,48.1875 5.4867,35.107 14.9023,25.4212 C13.4322,23.7996 12.5366,21.6566 12.5366,19.343 C12.5366,19.0932 12.5468,18.8407 12.5681,18.5868 C12.7776,16.1517 13.9183,13.9582 15.7814,12.3953 C17.6453,10.831 20.0082,10.0857 22.4349,10.2946 L22.4349,10.2946 L37.0544,11.5463 C37.1438,11.5538 37.2301,11.5733 37.3189,11.5834 C39.2746,4.901 45.465,0 52.7927,0 L52.7927,0 L101.8735,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1258,0 C58.5788,0 63,4.4212 63,9.8742 L63,90.5982 C63,98.5516 56.5516,105 48.5982,105 L14.4018,105 C6.4484,105 0,98.5516 0,90.5982 L0,9.8742 C0,4.4212 4.4212,0 9.8742,0 L53.1258,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9271,0 C62.9297,0 67,4.0749 67,9.0833 L67,99.9167 C67,104.9251 62.9297,109 57.9271,109 L9.0729,109 C4.0703,109 0,104.9251 0,99.9167 L0,9.0833 C0,4.0749 4.0703,0 9.0729,0 L57.9271,0 Z M57.9271,4.1923 L9.0729,4.1923 C6.379,4.1923 4.1875,6.3863 4.1875,9.0833 L4.1875,99.9167 C4.1875,102.6137 6.379,104.8077 9.0729,104.8077 L57.9271,104.8077 C60.621,104.8077 62.8125,102.6137 62.8125,99.9167 L62.8125,9.0833 C62.8125,6.3863 60.621,4.1923 57.9271,4.1923 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4091,0 L1.4091,2.8333 C1.4091,5.1807 3.3015,7.0833 5.6364,7.0833 L56.3636,7.0833 C58.6985,7.0833 60.5909,5.1807 60.5909,2.8333 L60.5909,0 L62,0 L62,12.9087 C62,15.1683 60.178,17 57.9305,17 L4.0695,17 C1.822,17 0,15.1683 0,12.9087 L0,0 L1.4091,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9546,0 C21.6197,0 19.7273,2.0145 19.7273,4.5 L19.7273,4.5 L19.7208454,4.64439324 C19.6525225,5.40473356 19.0502471,6 18.3182,6 L18.3182,6 L5.6364,6 C4.8586,6 4.2273,5.328 4.2273,4.5 L4.2273,4.5 L4.22242582,4.28195277 C4.11559957,1.89774265 2.26622647,0 0,0 L0,0 L23.9546,0 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5227,0 C6.7805,0 9.4733,2.5043 9.8256,5.7143 L21.1758,5.7143 C21.5281,2.5043 24.2195,0 27.4787,0 L31,0 L31,4.2857 L27.4773,4.2857 C26.312,4.2857 25.3636,5.2471 25.3636,6.4286 C25.3636,8.3971 23.7841,10 21.8409,10 L9.1591,10 C7.216,10 5.6364,8.3971 5.6364,6.4286 C5.6364,5.2471 4.688,4.2857 3.5227,4.2857 L0,4.2857 L0,0 L3.5227,0 Z",
    id: "path-11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Girar-dispositivo",
    transform: "translate(-232.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(232.500000, 262.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-76"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#F2F2F2",
    mask: "url(#mask-2)",
    points: "-1 124 -1 -1 119 -1 119 124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(45.500000, 9.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-78"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#84E9DF",
    mask: "url(#mask-4)",
    points: "-1 106 -1 -1 64 -1 64 106"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-82",
    transform: "translate(43.500000, 7.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#9051B1",
    mask: "url(#mask-6)",
    points: "-1 110 -1 -1 68 -1 68 110"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(46.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-84"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    fill: "#9051B1",
    mask: "url(#mask-8)",
    points: "-1 18 -1 -1 63 -1 63 18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-88",
    transform: "translate(65.522700, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-87"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    fill: "#9051B1",
    mask: "url(#mask-10)",
    points: "-4.5227 7 -4.5227 -1 28.4773 -1 28.4773 7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-91",
    transform: "translate(62.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#9051B1",
    mask: "url(#mask-12)",
    points: "-1 11 -1 -1 32 -1 32 11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-96",
    transform: "translate(9.500000, 19.500000)",
    stroke: "#9051B1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028665
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,82 C10.24355,75.10301 0,59.96194 0,42.39274 C0,25.0035 10.03478,9.9929 24.548,3",
    id: "Stroke-92"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-94",
    points: "22.53754 15 27 1.23242 12 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRote);
export default __webpack_public_path__ + "static/media/rote.0765a41fd96be12f558e23226547d622.svg";
export { ForwardRef as ReactComponent };